<template>
    <div id="login">

        <div id="login_module" class="col-10 col-sm-4 col-md-4 col-lg-3">
            <img src="https://www.leffix.playworld.nl/themes/assets/playworld/logo_200.png" alt="">
            <h2>Reset Wachtwoord</h2>
            <div id="form">
                 <div class="form-side" v-if="!this.verified && !this.reset_task.error"> 
                    <div class="roller"></div>
                    <h6 class="mb-4 text-center text-white">Verzoek wordt geverifieerd...</h6> 
                </div>
                <p v-if="reset_task.error || error" class="msg text-center text-danger">{{reset_task.error_msg}}</p>
                    <p v-if="reset_task.success" class="msg text-center text-success">{{reset_task.success_msg}}</p>
                <form v-if="this.verified && !this.reset_task.error && !this.reset_task.final_success" action="" @submit.prevent="send()">
                    <div class="form-group">
                        <input type="password" class="form-control" v-model="password" placeholder="Wachtwoord">
                    </div> 
                     <div class="form-group">
                        <input type="password" class="form-control" v-model="password_confirmation" placeholder="Bevestig Wachtwoord">
                    </div> 
                    <div class="form-group">
                        
                        <button :disabled="(reset_task.task_loader ? true:false)" class="btn btn-party btn-theme btn-block p-2" type="submit">
                            <div id="task_loader" v-if="reset_task.task_loader"></div>
                            {{'Bevestigen'}}
                        </button>
                    </div>
                    <a class="mb-2" href="/login">Terug naar inloggen</a> <br>
                    <br>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name:'forgotpassword',
    data(){
        return {
            verified:false,
            password:'',
            password_confirmation:'',
            reset_task:{
                sent:false,
                error:false,
                error_msg:'',
                success:false,
                success_msg:'',
                final_success:false,
                btntext:"INLOGGEN",
                task_loader:false
            },
            error:false,
            user_id:0,
        }
    },
    methods:{
        send(){
            this.reset_task.error=false;
            this.error=false;

            if(this.password.trim().length==0 || this.password_confirmation.trim().length==0){
                this.reset_task.error=true;
                this.reset_task.error_msg="Voer een nieuw wachtwoord in druk op bevestigen.";

                return false;
                
            }

            if(this.password != this.password_confirmation){
                this.error=true;
                this.reset_task.error_msg="Wachtwoorden komen niet overeen.";
                return false;
            }
            
            let password=this.password;
            if(password.length < 8){
                this.error=true;
                this.reset_task.error_msg="Wachtwoord moet minimaal 8 karakters hebben.";
                return false;
            }
            if(password.search(/[0-9]/) < 0){
                this.error=true;
                this.reset_task.error_msg="Wachtwoord moet minimaal 1 getal (0-9) bevatten.";
                return false;
            }
            if(password.search(/[A-Z]/) < 0){
                this.error=true;
                this.reset_task.error_msg="Wachtwoord moet minimaal 1 hoofdletter (A-Z) bevatten.";
                return false;
            }
            

            this.reset_task.task_loader=true;
            this.reset_task.btntext="Aan het inloggen...";
            let email=this.email;
            this.$store.dispatch('post',{endpoint:this.$store.state.endpoint+"reset-password/"+this.user_id , details:{password:this.password,password_confirmation:this.password_confirmation,token:this.$route.params.token}})
            .then(data=>{
                window.console.log(data);
                this.reset_task.final_success=true;
                this.reset_task.task_loader=false;
                this.reset_task.success=true;
                this.reset_task.success_msg= "Verificatie link is gemaild.";
                this.reset_task.btntext="Verstuur";
                this.password="";
                this.password_confirmation='';
                window.location.href="/login";
            })
            .catch(error=>{
                console.log('error', error.request);
                 
                // window.console.log(JSON.parse(error.request.response));
                this.reset_task.error=true;
                this.reset_task.error_msg="error in connectie, probeer opnieuw";

                this.reset_task.task_loader=false;
                this.reset_task.btntext="INLOGGEN";
            });
        }
    },
    created(){ 
        this.$store.dispatch('post',{endpoint:this.$store.state.endpoint+"verify-forget-password" , details:{token:this.$route.params.token}}).
        then(data=>{ 
            // console.log(data); 
            this.user_id=data.data;
            this.verified=true;
            
        })
        .catch(error=>{
            console.log(error.request);
            this.loading=false;
            if(error.request.status == 401 || error.request.status == 422){
                this.reset_task.error=true;
                this.verified=false;
                this.reset_task.error_msg="Invalid Reset token";
                return false;
            }

            this.reset_task.error=true;
            this.reset_task.error_msg="Connection error! please try again";
        });
    }
}
</script>

<style scoped>
    #task_loader{
        width: 20px;
        height: 20px;
        border: 2px solid gray;
        border-top: 2px solid white;
        border-radius: 50%;
        position: absolute;
        left: 15%;
        margin-top: 0.7%;
        animation: spin .6s linear infinite;
    }
     @keyframes spin{
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    body{
        background-color:#222 !important;
    }
    #login_module .foot{
        padding: 10px 16px;
    }
    #login_module .foot a{
        font-size: 13px;
        font-weight: bold;
        color: #545454;
    }
    #login_module{
        position: absolute;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
        background: #222;
        display: table;
        border-radius: 5px;
        box-shadow: 0px 0px 3px gray;
    }
    #login_module img{
        width: 265px;
        display: block;
        margin: 0 auto;
        margin-top: -13px;
        background-color: #222;
        border-radius: 7px;
        box-shadow: 0px 0px 2px grey;
        padding: 5px 7px;
    }
    #login_module h2{
        text-align: center;
        margin: 20px 0px;
        color: #faba05;
        font-weight: 700;
    }
    #login_module form{
        text-align: center;
        
    }
    #login_module form input:focus{
        border:1px solid #faba05;
        box-shadow: none;
    }
    .roller{
    display: block;
    border:2px solid lightgray;
    padding: 10px;
    width: fit-content;
    border-radius: 50%;
    border-top:2px solid red;
    animation:roll .4s linear infinite;
    margin: auto;
  }
  @keyframes roll {
    0%{
      transform: rotate(0deg)
    }
    100%{
      transform: rotate(360deg)
    }
  }

</style>
